import api from '.';

export const autorizacaoMesclagem = async (body) => (await api.post('/produto/mesclagem/autorizacao', body)).data;

// Revisão de duplicidades: erros permanecem rejeitados para o hook apresentar a mensagem.
export const identificarDuplicidades = async (body) => (await api.post('/produto/duplicidades/candidatos', body)).data;
export const compararDuplicidades = async (body) => (await api.post('/produto/duplicidades/comparar', body)).data;
export const gerarPreviaMesclagem = async (body) => (await api.post('/produto/mesclagem/previa', body)).data;
export const executarMesclagem = async (body) => (await api.post('/produto/mesclagem/executar', body)).data;
export const consultarMesclagem = async (body) => (await api.post('/produto/mesclagem/auditoria', body)).data;

export const prepararProdutoExistenteXml = async (obj) => {
    const { data } = await api.post('/produto/prepararProdutoExistenteXml', obj);
    return data;
};

export const embalagem = async (novaEmbalagem) => {
    try {
        const { data } = await api.post('/produto/embalagem', novaEmbalagem);
        return data;
    } catch (error) {
        return error;
    }
};

export const ncm = async (pesquisa, empresaId = 1) => {
    try {
        const { data } = await api.get('/serviceNCM', {
            params: { pesquisa, empresaId },
        });
        return data;
    } catch (error) {
        return error;
    }
};

export const operacao = async (entrada, saida, industria, balanco, manutencao, servico) => {
    try {
        const { data } = await api.get('/serviceOPERACAO', {
            params: { entrada, saida, industria, balanco, manutencao, servico },
        });
        return data;
    } catch (error) {
        return error;
    }
};

export const obterProdutoByIdOrUUID = async ({ id, uuid }) => {
    if (!id && !uuid) {
        return null;
    }
    try {
        const data = await api.get('/produto/obterProdutoByIdOrUUID', {
            params: { id, uuid },
        });

        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const cadastrar = (dados) =>
    api.post('/produto/cadastrar/', dados, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
export const cadastrarRapidoProdutoXml = async (obj) => {
    try {
        const { data } = await api.post('/produto/cadastrarRapidoXml/', obj);
        return data;
    } catch (error) {
        console.error(error);
        // O hook precisa receber a rejeição para exibir a mensagem original do backend.
        throw error;
    }
};
export const salvarProdutoEmbalagem = async (obj) => {
    try {
        const { data } = await api.post('/produto/embalagem/', obj);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const consulta = (uuid) => api.get(`/produto/editar/${uuid}`);

export const editar = (dados) =>
    api.post('/produto/editar/', dados, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

export const deletar = (selectedRow) => api.post('/produto/deletar/', selectedRow);

export const listar = ({ start, size, filters, filtersMode, globalFilter, sorting, categoria }) =>
    api.get('/produto/listar/', {
        params: { start, size, filters, filtersMode, globalFilter, sorting, categoria },
    });
/* modulo de inventário da mobilia */
export const listarInventario = ({ start, size, filters, filtersMode, globalFilter, sorting, produtoBensId }) =>
    api.get('/produto/listarInventario/', {
        params: { start, size, filters, filtersMode, globalFilter, sorting, produtoBensId },
    });

export const listarEmbalagens = (start, size, filters, filtersMode, globalFilter, sorting, produtoId) =>
    api.get('/produto/listarEmbalagens/', {
        params: { start, size, filters, filtersMode, globalFilter, sorting, produtoId },
    });

export const relatorio = (url, dadosFiltrados) =>
    api.post(`/produto/relatorio/?${url.toString()}`, dadosFiltrados, {
        responseType: 'arraybuffer',
    });

/**
 * UUIDs selecionados para incluir nota fiscal
 * @param {*} selectedUUIDs
 * @returns
 */
export const itensSelecionadosNF = (selectedUUIDs) => api.post('/produto/itensSelecionadosNF', selectedUUIDs);

//mobilia de inventario
export const mobilia = async (novaMobilia) => {
    try {
        const { data } = await api.post('/produto/mobilia', novaMobilia, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return { success: true, ...data };
    } catch (error) {
        return {
            success: false,
            message: error?.response?.data?.message || 'Erro ao salvar inventário',
            type: error?.response?.data?.type || 'error',
        };
    }
};

export const deletarMobilia = async (novaMobilia) => {
    try {
        const { data } = await api.post('/produto/deletarMobilia', novaMobilia);
        return data;
    } catch (error) {
        return error;
    }
};
// relatorios
export const inventario = (url, dadosFiltrados) =>
    api.post(`/produto/inventario/?${url.toString()}`, dadosFiltrados, {
        responseType: 'arraybuffer',
    });

//tratamento de imagens e pdf de not fiscal do inventario e do produto
export const editarInventarioBemImagem = (image) => api.post('/produto/editarInventarioBemImagem/', image);
export const editarInventarioBemPDF = (image) => api.post('/produto/editarInventarioBemPDF/', image);
export const deletarInventarioBemImagem = (image) => api.post('/produto/deletarInventarioBemImagem/', image);
export const deletarInventarioBemPDF = (image) => api.post('/produto/deletarInventarioBemPDF/', image);
/**
 * utilizar varios UUIDs para rotinas distintas
 * @param {*} selectedUUIDs
 * @param {*} tabela
 * @param {*} funcao para identificar o que sera feito com os dados
 * @returns
 */
export const reaproveitarFileByUUIDs = (selectedUUIDs, tabela, funcao) =>
    api.post('/produto/reaproveitarFileByUUIDs', selectedUUIDs, tabela, funcao);

export const reaproveitarNFs = (dados, novosDados) => api.post('/produto/reaproveitarNFs', dados, novosDados);

//serviços
export const bem = async (empresaId, ativo, filtro, condicao) => {
    try {
        const { data } = await api.get('/serviceBem', {
            params: {
                empresaId,
                ativo,
                filtro,
                condicao,
            },
        });
        return data;
    } catch (error) {
        return error;
    }
};

export const editarImagem = (image) => api.post('/produto/editarImagem/', image);
export const listarImagem = (start, size, filters, filtersMode, globalFilter, sorting, produtoId) =>
    api.get('/produto/listarImagem/', {
        params: { start, size, filters, filtersMode, globalFilter, sorting, produtoId },
    });
export const deletarImagem = (image) => api.post('/produto/deletarImagem/', image);

export const ultimoKm = async (produtoId, km) => {
    try {
        const { data } = await api.get('/serviceUltimoKm', {
            params: {
                produtoId,
                km,
            },
        });
        return data;
    } catch (error) {
        return error;
    }
};

//industria cores
export const createOrEditCor = async (novaCor) => {
    try {
        const { data } = await api.post('/produto/createOrEditCor', novaCor);
        return data;
    } catch (error) {
        return error;
    }
};
export const listarCores = ({ start, size, filters, filtersMode, globalFilter, sorting, produtoId }) =>
    api.get('/produto/listarCores/', {
        params: { start, size, filters, filtersMode, globalFilter, sorting, produtoId },
    });

//industria matéria-prima
export const createOrEditMateriaPrima = async (novaCor) => {
    try {
        const { data } = await api.post('/produto/createOrEditMateriaPrima', novaCor);
        return data;
    } catch (error) {
        return error;
    }
};
export const listarMateriaPrima = ({ start, size, filters, filtersMode, globalFilter, sorting, produtoId }) =>
    api.get('/produto/listarMateriaPrima/', {
        params: { start, size, filters, filtersMode, globalFilter, sorting, produtoId },
    });

export const buscarProdutosSemelhantes = async ({ empresaId, descricao, limite = 10 }) => {
    const response = await api.get('/produto/produtos-semelhantes', {
        params: {
            empresaId,
            descricao,
            limite,
        },
    });

    return response.data;
};
